import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { TiInfoOutline } from "react-icons/ti";
import axios from "../../../../../../Global/axios";
import { useNavigate, useParams } from "react-router-dom";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";
import { setArrayValues } from "./candidateListFunctions";
import nodeinstance from "../../../../../../nodeInstance";

export default function CandidateExcelUpload({
  showPromptElement,
  setShowPromptElement,
  setShowErrorPopUp,
  setCandidateListData,
  type,
  title,
  candidateData
}) {
  console.log("print the value in console",candidateData);
  
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const laravelToken = localStorage.getItem("token");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };
  const navigate = useNavigate();

  // const [excelData, setExcelData] = useState([]);

  const getData = async () => {
    try {
      const response = await axios.get(
        `/dashboard/project-candidates-list/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${laravelToken}`,
          },
        }
      );
      if (response.status === 200) {
        setArrayValues(response.data.data, setCandidateListData);
        // setExcelData(res.data.data);
      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };
  const CandidateFIleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("type", type);

    // Use nodeinstance for candidate_visa_details, otherwise use axios
    const Global =
      type === "candidate_visa_details" || type === "candidate_selection_list"
        ? nodeinstance
        : axios;
    const API =
      type === "candidate_visa_details"
        ? `/project-candidates-excel-import/${projectId}`
        : type === "candidate_selection_list"
          ? `/dashboard/projects/project-candidates-excel-import-selection/${projectId}`
          : `/dashboard/project-candidates-excel-import/${projectId}`;

    console.log("type to be printed in console", type, Global, API);

    const currentToken =
      type === "candidate_visa_details" || type === "candidate_selection_list"
        ? token
        : laravelToken;

    try {
      const res = await Global.post(API, formData, {
        headers: {
          Authorization: `Bearer ${currentToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("res to be seen in the console", res);
      if (res.status == 200) {
        if (
          type === "candidate_visa_details" ||
          type === "candidate_selection_list"
        ) {
          setLoading(false);

          // For selection list: show error popup if any rows failed, skip success toast
          if (type === "candidate_selection_list") {
            if (res?.data?.failedRecords?.length > 0) {
              // Import was aborted — show errors, do NOT close modal so user can re-upload
              setShowErrorPopUp(res.data.failedRecords);
              dispatch(setAppError({ msg: res.data.message }));
            } else {
              // Full success — refresh list then close modal
              await getData();
              dispatch(setAppError({ msg: res.data.message, color: "success" }));
              setShowPromptElement(false);
            }
          } else {
            // candidate_visa_details path (unchanged)
            await getData();
            dispatch(setAppError({ msg: res.data.message, color: "success" }));
            setShowPromptElement(false);
            if (res?.data?.failedRecords?.length > 0) {
              setShowErrorPopUp(res.data.failedRecords);
            }
          }
        } else {
          setArrayValues(res.data.data, setCandidateListData);
          setLoading(false);
          dispatch(
            setAppError({ msg: res.data.data.message, color: "success" })
          );
          setShowPromptElement(false);
          if (res?.data?.data?.validation_error) {
            setShowErrorPopUp(res.data.data.validation_error);
          } else if (res?.data?.data?.not_uploaded_passport_numbers) {
            setShowErrorPopUp(res.data.data.not_uploaded_passport_numbers);
          }
        }
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      dispatch(
        setAppError({ msg: error?.response?.data?.message || error?.message })
      );
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="w-full relative max-w-md   h-auto uppercase min-h-[14rem] rounded-md bg-white/90">
        <div className="flex flex-col gap-3 px-2 py-3">
          <div className="flex justify-between  items-center">
            <h2 className="block text-lg text-left font-bold text-gray-700 ">
              {title || "Upload Candidate File"}
            </h2>
            <AiFillCloseCircle
              className="cursor-pointer"
              size={"1.4rem"}
              onClick={() => {
                setShowPromptElement(false);
              }}
            />
          </div>
          <div className=" p-4  text-center flex justify-center flex-col">
            <input
              type="file"
              className="file-input file-input-bordered w-full"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
            />
            {/* {selectedFile && (
              <p className="text-green-500 mt-2">
                {selectedFile.name} selected
              </p>
            )} */}
          </div>
          <div className="text-center">
            <button
              className="px-1 py-2 w-full max-w-xs-ultra uppercase rounded-md ring-1 ring-red disabled:bg-rose-400 text-white bg-red"
              onClick={() => CandidateFIleSubmit()}
              disabled={loading || !selectedFile}
            >
              {loading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
